import { OverviewCardSection } from '@dtk/ui-components';
import { storyblokEditable } from '@storyblok/react';

export const OverviewCardSectionBlok = ({ ...props }) => {
  const { blok } = props;
  return (
    <div {...storyblokEditable(blok)} key={blok._uid} data-test="overview-card-section">
      <OverviewCardSection {...blok} />
    </div>
  );
};
